import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MegaMenuItem } from 'primeng/api';
import { UserModel } from 'src/app/models/dto/user.model';
import { GeneralServiceService } from 'src/app/services/general-service.service';
import { Constants } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {  
  paramSearch: any = "";
  loggato: boolean = false;
  user: UserModel;
  itemCart: any = 0;
  logoHeader: any;
  azienda: any;
  currentPage: any = 0;
  @Input() newItemEvent : any;
  openMenu: boolean = false;
  public screenHeight: any;
  @Input() minHeight: string= "0px";
  gfg: MegaMenuItem[];
  constructor(private router: Router, private genericFunction: GeneralServiceService, private activatedRoute: ActivatedRoute) { 
    this.user = new UserModel(null,null,null,null,null,null,null); 
  }

  ngOnInit(): void {
    this.screenHeight = window.innerHeight;
    
    this.azienda = Constants.nomeBreve;
  }

  toggleNavbar() {
    this.openMenu = !this.openMenu;
    if (this.openMenu) {
      this.minHeight = this.screenHeight + 'px';
    } else {
      this.minHeight = '0px';
    }
   
  }

  closeMenuMobile() {
    this.genericFunction.changeCurrentPage(0);
    this.openMenu = false;
    this.minHeight = '0px';
  }

  getMinHeigth() {
   
    
    if (this.openMenu) {
      return 'min-heigth:' + this.screenHeight + 'px';
    } else {
      return 'min-heigth: 0px';
    }
  }

  ngAfterViewInit() {
    this.minHeight = '0px';
   
    this.logoHeader = Constants.logo;
    this.loggato = this.genericFunction.loggato;
    this.user = this.genericFunction.currentUser;
    this.itemCart = this.genericFunction.totCart;
    
    this.getCategorie();
    this.genericFunction.subjectLoggato.subscribe((loggatoNew: boolean) => {
      this.loggato = loggatoNew;
    });

    this.genericFunction.subjectUser.subscribe((userNew: UserModel) => {
      this.user = userNew;
      
    });

    this.genericFunction.subjectCart.subscribe((totCartNew: any) => {
      this.itemCart = totCartNew;
      
    });
    this.genericFunction.subjectCurrentPage.subscribe((page: any) => {
      this.currentPage = page;
      
    })
  }

  addItem(value) {
    console.log("change");
    console.log(value);
  }

  cerca() {
    /*console.log(this.paramSearch);
    if (this.paramSearch != "") {

      let currentUrl = "/elencoProdotti/"+this.paramSearch;

     this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};

  //let currentUrl = this.router.url + '?';

  this.router.navigateByUrl(currentUrl)
    .then(() => {
      this.router.navigated = false;
      this.router.navigate([this.router.url]);
    });*/
   
      if (this.currentPage == 1) {
        let temp = this.router.url.split("/");
        let idCanvass = temp[2];
        console.log(idCanvass);
        this.router.navigateByUrl(this.router.url+"/"+this.paramSearch);
      } else {
        this.router.navigateByUrl("elencoProdotti/"+this.paramSearch);
      }
      
   // }
  }

  getCategorie() {
    let urlCat: any;
    if (this.currentPage == 1) {
      let temp = this.router.url.split("/");
      let idCanvass = temp[2];
      console.log(idCanvass);
      urlCat = this.router.url;
      
    } else {
      urlCat = "elencoProdottiCat/";
     
    }

    console.log("urlCat " + urlCat);
    let dataCategorie = {func:"CatSideBar"};
    this.genericFunction.genericFunction(dataCategorie).subscribe( response => {
      /* console.log(response); */
      let cat = response['Categorie'];
      let catTemp: any[] = [];
      

      for (let i= 0; i<cat.length;i++) {
        /* console.log(cat[i]); */
        let arrChild: any[] = [];
        let length;
        let indiceM ;

        if (cat[i]['children'].length <= 6) {
          length = Math.round(cat[i]['children'].length/2);
        } else if (cat[i]['children'].length > 18) { 
          let tempNumber = cat[i]['children'].length;
          console.log("tempNumber = " + tempNumber);
          indiceM = tempNumber/6;
         /*  console.log("indiceM = " + indiceM); */
          indiceM = Math.trunc(indiceM);
          
          let addMod = tempNumber%6;
          /* console.log("addMod = " + addMod); */
          indiceM = indiceM + addMod + 1;
         
          length = Math.round(cat[i]['children'].length/indiceM);
        } else if (cat[i]['children'].length >= 15 && cat[i]['children'].length < 18) {
          let tempNumber = cat[i]['children'].length;
          console.log("tempNumber = " + tempNumber);
          indiceM = tempNumber/5;
         /*  console.log("indiceM = " + indiceM); */
          indiceM = Math.trunc(indiceM);
          
          let addMod = tempNumber%5;
          /* console.log("addMod = " + addMod); */
          indiceM = indiceM + addMod + 1;
         
          length = Math.round(cat[i]['children'].length/indiceM);
        } else {
          length = Math.round(cat[i]['children'].length/3);
        }
        
        let child: any[] = new Array();
        
        for (let x=0;x<length;x++) {
          child[x] = new Array();
          let start;
          let end;
           if (cat[i]['children'].length <= 6) {
            
             start = x*2;
             end = start+2;
          } else if (cat[i]['children'].length > 18) { 
            start = x*indiceM;
            end = start+indiceM;
            console.log("start = " + start + " " + "end = " + end);
          } else { 
            start = x*3;
            end = start+3;
          }
          
          for (let y=start;y<end; y++) {
            let child1 = cat[i]['children'];
            
            if (child1[y]) {
              if (child1[y]['children']) {
                
                let arrChild3: any[] = [];
                for (let j =0;j<child1[y]['children'].length;j++) {
                  let child3=child1[y]['children'];
                 
                  arrChild3.push({ id: child3[j]['idcat'], label: child3[j]['titolo'], routerLink: "/elencoProdottiCat/"+child3[j]['idcat']+"/2", routerLinkActiveOptions: { exact: true }  });
                }
                child[x].push({id: child1[y]['idcat'], label: child1[y]['titolo'], items: arrChild3});
              } else {
                child[x].push({id: child1[y]['idcat'], label: child1[y]['titolo'], items:[{id: child1[y]['idcat'], label: child1[y]['titolo'],   routerLink:["/elencoProdottiCat/"+child1[y]['idcat']+"/1"], routerLinkActiveOptions: { exact: true } }],  routerLink:["/elencoProdottiCat/"+child1[y]['idcat']], routerLinkActiveOptions: { exact: true } });
              }
              
            }
           
          }
         // child[x].push(arrChild);
        }
       
        
        /* console.log(length + " - " + Math.round(length/3)); */
        
       
        let temp = {id: cat[i]['idcat'], label: cat[i]['titolo'], items: child};
        catTemp.push(temp);
      
      }

      this.gfg = catTemp;
      /* console.log(this.gfg); */
      
      
    });
  }

}
